import * as THREE from "three";
import Experience from "../Experience.js";

export default class Environment {
    constructor() {
        this.experience = new Experience();
        this.scene = this.experience.scene;
        this.resources = this.experience.resources;
        this.debug = this.experience.debug;

        this.params = {
            environmentIntensity: 0.5,
            backgroundIntensity: 0.8,
            envRotationY: 0,
            bgRotationY: 2.3,
        };

        // Debug
        if (this.debug.active) {
            this.debugFolder = this.debug.ui.addFolder("environment");
        }

        this.setEnvironmentMap();
    }

    setEnvironmentMap() {
        this.scene.environment = this.resources.items.environmentMapTexture;
        this.scene.background = this.resources.items.backgroundMapTexture;
        this.scene.environmentIntensity = this.params.environmentIntensity;
        this.scene.backgroundIntensity = this.params.backgroundIntensity;
        this.scene.environmentRotation.y = this.params.envRotationY;
        this.scene.backgroundRotation.y = this.params.bgRotationY;

        // Debug
        if (this.debug.active) {
            this.debugFolder
                .add(this.params, "backgroundIntensity")
                .name("bgIntensity")
                .min(0)
                .max(4)
                .step(0.001)
                .onChange((value) => {
                    this.scene.backgroundIntensity = value;
                });

            this.debugFolder
                .add(this.params, "environmentIntensity")
                .name("envIntensity")
                .min(0)
                .max(4)
                .step(0.001)
                .onChange((value) => {
                    this.scene.environmentIntensity = value;
                });

            this.debugFolder
                .add(this.params, "envRotationY")
                .name("envRotationY")
                .min(0)
                .max(Math.PI * 2)
                .step(0.001)
                .onChange((value) => {
                    this.scene.environmentRotation.y = value;
                });

            this.debugFolder
                .add(this.params, "bgRotationY")
                .name("bgRotationY")
                .min(0)
                .max(Math.PI * 2)
                .step(0.001)
                .onChange((value) => {
                    this.scene.backgroundRotation.y = value;
                });
        }
    }
}
